<template>
    <div class="footer">
        <div class="footer__copyright">
            &#169; SHGI Corp. 2002 - {{currentYear}}
        </div>
        <ul class="footer__links">
            <li class="link">
              <a :href="hgRootUrl + 'buyer/home-buyer/'" target="_blank">About Us</a>
            </li>
            <li class="link">
              <a :href="hgRootUrl + 'contact.html'" target="_blank">Contact</a>
            </li>
            <li class="link">
              <a :href="hgRootUrl + 'hg-terms.html'" target="_blank">Terms of Use</a>
            </li>
            <li class="link">
              <a :href="hgRootUrl + 'privacy.html'" target="_blank">Privacy</a>
            </li>
        </ul>
    </div>
</template>

<script>

export default {
  data() {
    return {
      hgRootUrl: process.env.VUE_APP_HG_CLASSIC,
    };
  },
  computed: {
    currentYear() {
      return new Date().getUTCFullYear();
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
    max-width: 825px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 32px;

    &__copyright {
        color: #a4a4a4;
        font-size: 14px;
        font-weight: 500;
    }

    &__links {
        display: flex;
        gap: 24px;
        padding: 0;
    }
}

.link {
    display: block;
    a {
        color: #a4a4a4;
        font-size: 14px;
        font-weight: 500;
        text-decoration: underline;
    }
}

@media all and (max-width: 655px) {
    .footer {
        background: #fff;
        padding: 100px 15px 0;
        flex-direction: column;
        align-items: flex-start;

        &__links {
            margin-top: 16px;
            padding-bottom: 16px;
        }
    }
}
</style>
